import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { initials } from "@/lib/brand";
import { Menu, LogOut, Settings as SettingsIcon } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { NotificationBell } from "./NotificationBell";

export function Topbar({ isClient, user, onOpenMenu }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <header className="h-16 shrink-0 border-b border-slate-200 bg-white flex items-center justify-between px-4 md:px-8">
      <div className="flex items-center gap-3">
        <button className="md:hidden" onClick={onOpenMenu} data-testid="open-menu-btn">
          <Menu size={22} />
        </button>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-slate-400">
            {isClient ? user.client?.name || "Client" : "Agency Console"}
          </p>
          <h2 className="font-display font-semibold text-slate-900 text-lg leading-none">
            {isClient ? "Project Portal" : "Operations"}
          </h2>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <NotificationBell />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2 rounded-md hover:bg-slate-100 px-2 py-1.5" data-testid="user-menu-btn">
              <Avatar className="h-8 w-8">
                <AvatarFallback className="text-white text-xs" style={{ background: "var(--tenant-primary)" }}>
                  {initials(user.name)}
                </AvatarFallback>
              </Avatar>
              <div className="hidden sm:block text-left leading-tight">
                <p className="text-sm font-medium text-slate-800">{user.name}</p>
                <p className="text-[11px] text-slate-400 capitalize">{user.role}</p>
              </div>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuLabel className="truncate">{user.email}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => navigate("/settings")} data-testid="settings-menu-item">
              <SettingsIcon size={15} className="mr-2" /> Settings
            </DropdownMenuItem>
            <DropdownMenuItem onClick={logout} data-testid="logout-btn" className="text-red-600">
              <LogOut size={15} className="mr-2" /> Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
